<script setup>
import { useTheme } from "vuetify";
const theme = useTheme();
const props = defineProps({
    height: {
        type: String,
        default: '50',
    },

    darkLogo: {
        type: Boolean,
        default: false,
    },
    width: {
        type: String,
        default: '150px',
    },
    mdWidth: {
        type: String,
        default: '200px',
    },
    maxWidth: {
        type: String,
        default: '200px',
    },
    lightLogo: {
        type: Boolean,
        default: false,
    },
});

</script>
<template>
    <!-- <div> -->
    <!-- class="h-20 w-30" -->
    <Link href="/">
    <v-img v-if="theme.global.current.value.dark && !lightLogo || darkLogo" alt="logo"
        :src="$page.props.setting.home_logo" :lazy-src="$page.props.setting.home_logo" :height="height" :width="width"
        :class="`max-w-[${maxWidth}] w-[${width}] md:w-[${mdWidth}] pb-0`" />
    <v-img v-else alt="logo" :src="$page.props.setting.home_logolight" :lazy-src="$page.props.setting.home_logolight"
        :height="height" :width="width" :class="`max-w-[${maxWidth}] w-[${width}] md:w-[${mdWidth}] pb-0`" />
    </Link>
    <!-- </div> -->
</template>
